import * as Sentry from '@sentry/browser';

const config = window.APP_CONFIG?.sentry || {};

Sentry.init({
  dsn: config.dsn,
  environment: config.environment,
  release: config.release,
  allowUrls: config.allowUrls,
});
